import React, { Fragment } from "react";
import NewGame from "./NewGame";
import JoinGame from "./JoinGame";

export const Home = () => {
  return (
    <Fragment>
      <div className="App">
        <NewGame />
        <JoinGame />
      </div>
    </Fragment>
  );
};
